"use strict";
// ===========================================
//  library
// ===========================================

import * as modGsap from "../../utility/_gsap";
import { slideUpLetters } from "../../utility/_scrollAnimation";
import { initLenis } from "../../utility/_lenis";
import { pageTopView } from "../../utility/_returnTopButton";

import { scrollVisivleHeaderBg, countUp } from "../../utility/_modules";
import {
  layerKv,
  layerSectionTitle,
  // fixedNav,
} from "../../utility//_layerModules";
// ===========================================
//  variable
// ===========================================
const activeClass = "is-active";

// ===========================================
//  setup
// ===========================================
// ===========================================
//  load　読み込み
// ===========================================
window.addEventListener("DOMContentLoaded", () => {
  const layerContent = document.querySelector(".u-layer-content");
  scrollVisivleHeaderBg(layerContent);
  // modGsap.init();
  // fixedNav();
  slideUpLetters();
  layerKv();
  layerSectionTitle();
  pageTopView();
  countUp();
  initLenis();
});
